'use strict';

import DataTable from 'datatables.net-bs4';

const {__} = wp.i18n;

/**
 * Init All Boundaries Admin Side
 */
class TWER_BOUNDARIES {

  $boundariesCheckbox = null;
  $regionsSelect = null;
  $preloader = null;

  boundariesLoaded = false;

  worldsSlugs = ['world', 'united-states', 'united-kingdom', 'spain', 'italy', 'germany', 'france', 'canada', 'australia'];
  accuracyList = ['very_high', 'high', 'medium', 'low', 'very_low'];
  worldsList = {};
  worldsGeoJson = {};
  regionsList = {};

  hoveredStateId = null;
  selectStateIds = [];
  selectStateIdsColors = [];
  hiddenRegionsIds = new Set();
  allCheckboxesStates = [];
  allLinks = [];
  allValues = [];
  table = null;
  currentLinkEdit = null;

  sectionsForLoad = ['section-treweler-boundaries-regions', 'section-treweler-boundaries-fill', 'section-treweler-boundaries-stroke', 'section-treweler-boundaries-onclick', 'section-treweler-boundaries-onhover', 'section-treweler-boundaries-polygons'];

  constructor() {
    this.$boundariesCheckbox = document.getElementById('treweler-boundaries');
    this.$regionsSelect = document.getElementById('treweler-boundaries-regions');

    this.worldListFill();
    this.boundariesCheckboxWatch();

    $(document).on('click', '.js-twer-color-picker-wrap-o .js-twer-color-picker-o', (event) => {
      event.preventDefault();
      const $colorPicker = $(event.target);
      const $colorPickerCell = $colorPicker.find('.color-holder');
      const $colorPickerWrap = $colorPicker.closest('.js-twer-color-picker-wrap-o');
      const id = $colorPickerWrap.attr('id');
      const $palette = $colorPickerWrap.find('.js-twer-color-picker-palette-o');
      const $colorInput = $colorPickerWrap.find('.input-color');
      const $colorDefaultInput = $colorPickerWrap.find('.js-twer-colorpicker-custom-color');
      let colorValue = $colorInput.val();
      if ($palette.find('.a-color-picker').length === 0) {
        TWER_HELPERS.AColorPicker.from($palette[0], {
          showRGB: false,
          showHSL: false,
          paletteEditable: true,
          showAlpha: true,
          //useAlphaInPalette : true,
          color: colorValue
        }).on('change', (picker, color) => {

          $(picker.element).closest('.js-twer-color-picker-wrap-o').find('.color-holder').css('background-color', picker.color);
          $colorInput.val(picker.color);
          $palette.attr('acp-color', picker.color);
          let colorValue1 = 1;
          if (picker.color.includes('rgba')) {
            colorValue1 = picker.color.split(',');
            colorValue1 = parseFloat(colorValue1[colorValue1.length - 1]);
          }
          $(picker.element).find('.js-twer-colorpicker-opacity').val(colorValue1);

          if ($colorPickerWrap.closest('.js-twer-region-row').size() > 0) {
            const $row = $colorPickerWrap.closest('.js-twer-region-row');
            const checked = $row.find('.js-twer-region-override_color').prop('checked');
            const checkedRow = $row.find('.js-twer-region-active').prop('checked');
            const feature = $row.data('feature');
            const id = parseInt(feature.id);
            const selectedId = this.checkIdHasCustomColor(id);

            if (!selectedId.hasColor) {
              this.selectStateIdsColors.push({
                'id': id,
                'color': picker.color,
                'active': !!checked,
                'selected': !!checkedRow
              });
            } else {
              if (this.selectStateIdsColors.length > 0) {
                for (let i = 0; i < this.selectStateIdsColors.length; i++) {
                  if (this.selectStateIdsColors[i].id === id) {
                    this.selectStateIdsColors[i].color = picker.color;
                    this.selectStateIdsColors[i].active = !!checked;
                    this.selectStateIdsColors[i].selected = !!checkedRow;
                  }
                }
              }
            }

            $('#treweler-boundaries-regions-custom-colors').val(JSON.stringify(this.selectStateIdsColors));
            if (checked) {
              this.fillRegionColor(id, {action: 'customize'});
            }

          }

          if ('overlay-style-map' === id) {
            TWER.map.setPaintProperty('bg-layer', 'background-color', picker.color);
          }

          if ('treweler-boundaries-fill-main' === id) {
            this.fillRegionColor(null, {main: picker.color});
          }

          if ('treweler-boundaries-fill-hover' === id) {
            this.fillRegionColor(null, {hover: picker.color});
          }

          if ('treweler-boundaries-fill-selected' === id) {
            this.fillRegionColor(null, {select: picker.color});
          }

          if ('treweler-boundaries-stroke-color' === id) {
            for (let i = 0; i < this.accuracyList.length; i++) {
              TWER.map.setPaintProperty(`boundaries-${this.accuracyList[i]}-line-layer`, 'line-color', picker.color);
            }
          }

        }).on('coloradd', (picker, color) => {
          let cca = $colorDefaultInput;
          if (cca.val().indexOf('|' + picker.color) === -1) {
            cca.val(cca.val() + '|' + picker.color);
            $.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: cca.val()},
              success: function(response) {
                let defaultCP = $palette.attr('data-default-palette');
                $palette.attr('acp-palette', defaultCP + '' + response);
                $palette.attr('acp-palette', defaultCP + '' + response);
                //colorPicker.attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        }).on('colorremove', (picker, color) => {
          let ccr = $colorDefaultInput;
          if (ccr.val().indexOf('|' + picker.color) !== -1) {
            let sc = ccr.val().replace('|' + picker.color, '');
            ccr.val(sc);
            $.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: ccr.val()},
              success: function(response) {
                let defaultCP = $palette.attr('data-default-palette');
                $palette.attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        });

        if (colorValue.includes('rgba')) {
          colorValue = colorValue.split(',');
          colorValue = parseFloat(colorValue[colorValue.length - 1]);
        } else {
          colorValue = 1;
        }

        $('.a-color-picker-rgbhex').append('<input type="text" class="twer-colorpicker-opacity js-twer-colorpicker-opacity" value="' + colorValue + '" disabled>');

      } else {
        //$palette.find('.a-color-picker').remove();
      }

    });

    $(document).on('click', '.js-twer-color-picker-palette-o', function(event) {
      //event.stopPropagation();
    });

    $(document).on('click', function(event) {
      if (!$(event.target).closest('.js-twer-color-picker-wrap-o').length > 0) {
        $('.js-twer-color-picker-palette-o').find('.a-color-picker').remove();
      }
    });
  }


  unloadBoundaries() {
    for (let s = 0; s < this.sectionsForLoad.length; s++) {
      document.getElementsByClassName(this.sectionsForLoad[s])[0].classList.remove('twer-show-section');
    }

    if (this.boundariesLoaded) {
      for (let i = 0; i < this.accuracyList.length; i++) {
        TWER.map.setLayoutProperty(`boundaries-${this.accuracyList[i]}-layer`, 'visibility', 'none');
        TWER.map.setLayoutProperty(`boundaries-${this.accuracyList[i]}-line-layer`, 'visibility', 'none');
      }
    }
  }

  loadBoundaries() {

    this.$preloader = document.createElement('span');
    this.$preloader.classList.add('spinner', 'is-active');
    this.$boundariesCheckbox.closest('.twer-switcher').appendChild(this.$preloader);

    if (!this.boundariesLoaded) {

      this.fetchData().then((geoJSON) => {

        this.$preloader.remove();
        for (let s = 0; s < this.sectionsForLoad.length; s++) {
          document.getElementsByClassName(this.sectionsForLoad[s])[0].classList.add('twer-show-section');
        }

        this.worldsGeoJson = this.prepareGeoJson(geoJSON);
        this.regionsList = this.generateRegionsList();

        this.updateSelectRegionsList();

        this.mapboxApplyGeoJson();






        TWER.map.once('idle', (e) => {
          setTimeout(()=>{
            const allLayers = TWER.map.getStyle().layers;
            for(let i = 0; i < allLayers.length; i++) {
              const layerId = allLayers[i].id;
              if(layerId.includes('boundaries-')) {
                TWER.map.moveLayer(layerId);
              }
            }
          }, 1000);
        });

      }).catch(error => {
        console.log(error);
      });

      this.boundariesLoaded = true;
    } else {
      this.$preloader.remove();
      for (let s = 0; s < this.sectionsForLoad.length; s++) {
        document.getElementsByClassName(this.sectionsForLoad[s])[0].classList.add('twer-show-section');
      }
      const currentAccuracy = $('#treweler-boundaries-regions-accuracy').val();

      for (let i = 0; i < this.accuracyList.length; i++) {
        if (currentAccuracy === this.accuracyList[i]) {
          TWER.map.setLayoutProperty(`boundaries-${this.accuracyList[i]}-layer`, 'visibility', 'visible');
          TWER.map.setLayoutProperty(`boundaries-${this.accuracyList[i]}-line-layer`, 'visibility', 'visible');
        } else {
          TWER.map.setLayoutProperty(`boundaries-${this.accuracyList[i]}-layer`, 'visibility', 'none');
          TWER.map.setLayoutProperty(`boundaries-${this.accuracyList[i]}-line-layer`, 'visibility', 'none');
        }
      }
    }

  }

  prepare_regions(choosedRegion) {
    const preparedCurrentRegion = 'world' === choosedRegion ? {} : JSON.parse(choosedRegion);
    const isEmpty = Object.keys(preparedCurrentRegion).length === 0;

    let column = '';
    let column_value = '';

    let admin_column = '';
    let admin_value = -1;

    if (!isEmpty) {
      for (let column_inner in preparedCurrentRegion) {
        if (column_inner === 'ADMIN') {
          admin_column = column_inner;
          admin_value = preparedCurrentRegion[column_inner];
        } else {
          column = column_inner;
          column_value = preparedCurrentRegion[column_inner];
        }
      }
    } else {
      column = 'world';
    }

    return {
      column: column,
      value: column_value,
      admin: admin_column,
      admin_num: parseInt(admin_value)
    };
  }

  fillRegionColor(featureId, settings = {}) {
    const action = 'action' in settings ? settings.action : false;
    const filter = this.generateFeatureStateFilter(settings);

    for (let i = 0; i < this.accuracyList.length; i++) {
      TWER.map.setPaintProperty(`boundaries-${this.accuracyList[i]}-layer`, 'fill-color', filter);
      if (action) {
        let stateAction = action;
        switch (action) {
          case 'customize' :
            stateAction = `customize_${featureId}`;
            break;
        }
        TWER.map.setFeatureState(
          {source: this.accuracyList[i], id: featureId},
          {action: stateAction}
        );
      }
    }

  }

  generateRowForDataTable() {
    let dataTableArray = [];
    const globalCheckedVals = this.getAllCheckboxVal();
    const getAllValues = this.getAllValues();
    const links = this.getAllLinks();
    this.hiddenRegionsIds = this.hiddenRegionsIds.size !== 0 ? this.hiddenRegionsIds : $('#treweler-boundaries-regions-hide').val().trim();
    if (typeof this.hiddenRegionsIds === 'string') {
      if (this.hiddenRegionsIds === '') {
        this.hiddenRegionsIds = '[]';
      }
      this.hiddenRegionsIds = new Set(JSON.parse(this.hiddenRegionsIds));
    }

    this.selectStateIds = this.selectStateIds.length > 0 ? this.selectStateIds : $('#treweler-boundaries-regions-selected').val().trim();
    if (!Array.isArray(this.selectStateIds)) {
      if (this.selectStateIds === '') {
        this.selectStateIds = '[]';
      }
      this.selectStateIds = JSON.parse(this.selectStateIds);
    }

    this.selectStateIdsColors = this.selectStateIdsColors.length > 0 ? this.selectStateIdsColors : $('#treweler-boundaries-regions-custom-colors').val().trim();

    if (!Array.isArray(this.selectStateIdsColors)) {
      if (this.selectStateIdsColors === '') {
        this.selectStateIdsColors = '[]';
      }
      this.selectStateIdsColors = JSON.parse(this.selectStateIdsColors);
    }

    if (globalCheckedVals.length > 0) {
      for (let i = 0; i < globalCheckedVals.length; i++) {
        $('.js-twer-active-all-regions').prop('checked', globalCheckedVals[i].active);
        $('.js-twer-hide-all-regions').prop('checked', globalCheckedVals[i].hide);
      }
    } else {
      $('.js-twer-active-all-regions, .js-twer-hide-all-regions').prop('checked', false);
    }



    for (let k = 0; k < this.worldsGeoJson.very_high.features.length; k++) {
      const featureRow = this.worldsGeoJson.very_high.features[k];
      const featureRowId = parseInt(featureRow.id);
      const featureProperties = featureRow.properties;
      const featureRowName = featureProperties.NAME;
      const preparedRegion = this.prepare_regions(this.$regionsSelect.value);

      let addFlag = false;

      if (preparedRegion.column === 'world' && !featureProperties.hasOwnProperty('COUNTRY') && !featureProperties.hasOwnProperty('ADMIN')) {
        addFlag = true;
      }

      if (preparedRegion.column !== 'world') {
        if (featureProperties[preparedRegion.column] === preparedRegion.value) {
          if (featureProperties.hasOwnProperty('ADMIN')) {
            if (featureProperties[preparedRegion.admin] === preparedRegion.admin_num) {
              addFlag = true;
            }
          } else {
            addFlag = true;
          }
        }
      }

      if (addFlag) {
        let tr = [];
        for (let j = 0; j < 7; j++) {
          switch (j) {
            case 0 :
              let checkedSelect = '';
              if (this.selectStateIds.length > 0 && Array.isArray(this.selectStateIds)) {
                const selectedId = this.checkIdHasCustomColor(featureRowId);
                if (this.selectStateIds.includes(featureRowId) && selectedId.selected) {
                  checkedSelect = 'checked="checked"';
                }
              }

              tr.push(`<label for="twer-active-${featureRowId}" class="twer-switcher">
                                  <input type="checkbox" class="js-twer-region-active" id="twer-active-${featureRowId}" ${checkedSelect} value="active">
                                  <span class="twer-switcher__slider"></span>
                              </label>`);
              break;
            case 1 :
              let delHTML = `<a href="#" class="twer-del-link js-twer-del-link" title=""></a>`;
              let linkHTML = `<a href="" target class="js-twer-set-link twer-set-link" title=""></a><span>${featureRowName}</span>`;
              if (links.length > 0) {
                const linkData = this.getFeatureLinkVal(featureRowId);
                if (linkData) {
                  linkHTML = `<a href="${linkData.url}" target="${linkData.target}" class="js-twer-set-link twer-set-link twer-set-link--active" title="${linkData.title}">${linkData.title}</a><span>${featureRowName}</span>`;
                  delHTML = `<a href="#" class="twer-del-link js-twer-del-link twer-del-link--active" title=""></a>`;
                }
              }

              tr.push(`<span class="d-none">${featureRowName}</span><div class="js-twer-link-wrap twer-link-wrap">${delHTML}<div class="twer-set-link-wrap">${linkHTML}</div></div>`);
              break;
            case 2 :
              let region = '';

              if(featureProperties.hasOwnProperty('SUBREGION') ) {
                region = featureProperties.SUBREGION;
              }

              if(featureProperties.hasOwnProperty('ADMIN')){
                const adminValue = featureProperties.ADMIN;

                if(adminValue === 1) {
                  if(featureProperties.hasOwnProperty('COUNTRY')) {
                    region = featureProperties.COUNTRY;
                  }
                }
                if(adminValue === 2) {
                  if(featureProperties.hasOwnProperty('NAME_1')) {
                    region = featureProperties.NAME_1;
                  }
                }
              }

              tr.push(region);
              break;
            case 3 :
              let checkedColor = '';
              let colorValue = 'rgba(255, 255, 255, 0)';
              if (this.selectStateIdsColors.length > 0 && Array.isArray(this.selectStateIdsColors)) {
                const selectedId = this.checkIdHasCustomColor(featureRowId);
                if (selectedId.hasColor && selectedId.active) {
                  checkedColor = 'checked="checked"';
                  colorValue = this.selectStateIdsColors[selectedId.index].color;
                } else if (selectedId.hasColor && !selectedId.active) {
                  checkedColor = '';
                  colorValue = this.selectStateIdsColors[selectedId.index].color;
                } else {
                  checkedColor = '';
                  colorValue = 'rgba(255, 255, 255, 0)';
                }
              }

              tr.push(`<div class="row flex-nowrap">
                                  <div class="col-auto pr-0">
                                      <label for="twer-override-${featureRowId}" class="twer-switcher">
                                          <input type="checkbox" class="js-twer-region-override_color" ${checkedColor} id="twer-override-${featureRowId}" value="override_color">
                                          <span class="twer-switcher__slider"></span>
                                      </label>
                                  </div>
                                  <div class="col-auto">
                                      <div class="clearfix">
                                          <div id="twer-color-${featureRowId}" class="js-twer-color-picker-wrap-o twer-color-picker-wrap">
                                              <div class="map-text-color js-twer-color-picker-o">
                                                  <span class="color-holder" style="background-color:${colorValue};"></span>
                                                  <input type="button" class="text-color-picker-btn" value="">
                                              </div>
                                              <div class="js-twer-color-picker-palette-o twer-color-picker-palette"
                                                   acp-color="${colorValue}"
                                                    acp-palette="${twer_ajax.default_colors}${twer_ajax.custom_colors}"
                                                   default-palette="${twer_ajax.default_colors}"
                                                   acp-show-rgb="no"
                                                   acp-show-hsl="no"
                                                   acp-palette-editable>
                                              </div>
                                              <input type="hidden" class="input-color" value="${colorValue}">
                                              <input type="hidden" class="js-twer-colorpicker-custom-color" value="${twer_ajax.custom_colors}">
                                          </div>
                                      </div>
                                  </div>
                              </div>`);
              break;
            case 4 :
              let innerContent = '';
              let innerClass = '';
              if (!this.allValuesIsEmpty()) {
                const valueData = this.getFeatureValueVal(featureRowId);
                if (valueData) {
                  innerContent = valueData.value;
                  innerClass = 'twer-region-value-cell--has-value';
                }
              }

              tr.push(`<div class="js-twer-region-value-cell twer-region-value-cell ${innerClass}">${innerContent}</div>`);
              break;
            case 5 :
              let checkedHide = '';
              if (this.hiddenRegionsIds.size !== 0) {
                if (this.hiddenRegionsIds.has(featureRowId)) {
                  checkedHide = 'checked="checked"';
                }
              }

              tr.push(`<label for="twer-hide-${featureRowId}" class="twer-switcher">
                                  <input type="checkbox" class="js-twer-region-hide" id="twer-hide-${featureRowId}" ${checkedHide} value="hide">
                                  <span class="twer-switcher__slider"></span>
                              </label>`);
              break;
            case 6 :
              tr.push(JSON.stringify({id: featureRowId, properties: featureRow.properties}));
              break;
          }
        }

        dataTableArray.push(tr);
      }
    }

    return dataTableArray;
  }

  updateDataTable() {
    this.table.clear();
    this.table.rows.add(this.generateRowForDataTable());
    this.table.draw();
  }

  mapboxApplyGeoJson() {
    let strokeColor = $('#treweler-boundaries-stroke-color .input-color').val();
    let strokeWidthValue = parseFloat($('#treweler-boundaries-stroke-width').val());
    let strokeWidth = isNaN(strokeWidthValue) ? 1 : strokeWidthValue;
    let accValue = $('#treweler-boundaries-regions-accuracy').val();

    for (let i = 0; i < this.accuracyList.length; i++) {
      const key = this.accuracyList[i];

      const layer = {
        'type': 'fill',
        'layout': {
          'visibility': 'none',
        },
        'paint': {
          'fill-color': this.generateFeatureStateFilter(),
          'fill-outline-color': 'rgba(255, 255, 255, 0)'
        }
      };
      const layerLine = {
        'type': 'line',
        'layout': {
          'visibility': 'none',
        },
        'paint': {
          'line-width': strokeWidth,
          'line-color': strokeColor
        }
      };
      const filter = this.generateRegionsFilter($('#treweler-boundaries-regions').val());


      layer.filter = filter;
      layerLine.filter = filter;

      TWER.map.addSource(key, {
        'type': 'geojson',
        'data': this.worldsGeoJson[key]
      });

      layer.id = `boundaries-${key}-layer`;
      layer.source = key;

      layerLine.id = `boundaries-${key}-line-layer`;
      layerLine.source = key;

      if (key === accValue) {
        layer.layout.visibility = 'visible';
        layerLine.layout.visibility = 'visible';
      }

      // Add a layer showing the state polygons.
      TWER.map.addLayer(layer);
      TWER.map.addLayer(layerLine);

      TWER.map.on('mouseenter', `boundaries-${key}-layer`, () => {
        TWER.map.getCanvas().style.cursor = 'pointer';
      });
      TWER.map.on('mousemove', `boundaries-${key}-layer`, (e) => {
        if (e.features.length > 0) {
          const currentId = e.features[0].id;
          if (!this.selectStateIds.includes(currentId)) {
            if (this.hoveredStateId !== null) {
              this.fillRegionColor(this.hoveredStateId, {action: 'unhover'});
            }
            this.hoveredStateId = e.features[0].id;
            this.fillRegionColor(this.hoveredStateId, {action: 'hover'});
          } else {
            if (this.hoveredStateId !== null) {
              this.fillRegionColor(this.hoveredStateId, {action: 'unhover'});
            }
            this.hoveredStateId = null;
          }

          if (this.selectStateIds.length > 0) {
            for (let i = 0; i < this.selectStateIds.length; i++) {
              this.fillRegionColor(this.selectStateIds[i], {action: 'select'});
            }
          }

          if (this.selectStateIdsColors.length > 0) {
            for (let i = 0; i < this.selectStateIdsColors.length; i++) {
              if (this.selectStateIdsColors[i].active && this.selectStateIds.includes(this.selectStateIdsColors[i].id)) {
                this.fillRegionColor(this.selectStateIdsColors[i].id, {action: 'customize'});
              }
            }
          }
          //popup(e);
        }
      });
      TWER.map.on('click', `boundaries-${key}-layer`, (e) => {
        if (e.features.length > 0) {
          const id = e.features[0].id;
          const selectedId = this.checkIdHasCustomColor(id);

          if (!selectedId.active) {
            if (!this.selectStateIds.includes(id)) {
              this.fillRegionColor(id, {action: 'select'});
              this.selectStateIds.push(id);
            } else {
              this.fillRegionColor(id, {action: 'unselect'});
              this.selectStateIds = this.selectStateIds.filter(item => item !== id);
            }

            $('#treweler-boundaries-regions-selected').val(JSON.stringify(this.selectStateIds));

            this.updateDataTable();
          }

          this.setAllCheckboxVal();

        }
      });
      TWER.map.on('mouseleave', `boundaries-${key}-layer`, (e) => {
        if (this.hoveredStateId !== null) {
          this.fillRegionColor(this.hoveredStateId, {action: 'unhover'});
        }
        this.hoveredStateId = null;
        //popup();
        TWER.map.getCanvas().style.cursor = '';
      });


    }

    this.selectRegions();
    //this.selectHiddenRegions();

    this.table = new DataTable('#js-twer-regions-datatable', {
      responsive: true,
      data: this.generateRowForDataTable(),
      dom: '<\'row\'<\'col-sm-6\'f><\'col-sm-6\'l>>' +
           '<\'row\'<\'col-sm-12\'tr>>' +
           '<\'row\'<\'col-12\'i><\'col-12\'p>>',
      language: {
        lengthMenu: __('Show Entries&nbsp;&nbsp;_MENU_', 'treweler'),
      },
      ordering: true,
      columnDefs: [
        {
          orderable: false,
          targets: 'no-sort'
        }],
      order: [[1, 'asc']],
      info: false,
      createdRow: (row, data, dataIndex) => {
        row.classList.add('js-twer-region-row');
        row.dataset.feature = data[6];
      },
      deferRender: true,
    });

    $(document).on('keyup', '#treweler-boundaries-stroke-width', (e) => {
      let value = e.target.value;
      let default_value = 1;
      if (value.trim() === '') {
        value = default_value;
      }
      for (let i = 0; i < this.accuracyList.length; i++) {
        TWER.map.setPaintProperty(`boundaries-${this.accuracyList[i]}-line-layer`, 'line-width', parseInt(value));
      }
    });

    $(document).on('change', '#treweler-boundaries-regions', (e) => {
      const thisValue = e.target.value;

      const filter = this.generateRegionsFilter(thisValue);

      this.$regionsSelect.dataset.value = thisValue;

      for (let i = 0; i < this.accuracyList.length; i++) {
        TWER.map.setFilter(`boundaries-${this.accuracyList[i]}-layer`, filter);
        TWER.map.setFilter(`boundaries-${this.accuracyList[i]}-line-layer`, filter);
      }

      this.updateDataTable();

      const allData = this.table.rows().data();
      let checkedSelect = 0;
      let checkedHide = 0;

      for (let i = 0; i < allData.length; i++) {
        const selectCol = allData[i][0];
        const hideCol = allData[i][5];


        if (selectCol.includes('checked')) {
          checkedSelect++;
        }
        if (hideCol.includes('checked')) {
          checkedHide++;
        }
      }

      this.setAllCheckboxVal(checkedSelect === allData.length);
      this.setHiddenCheckboxVal(checkedHide === allData.length);
    });

    // Toggle Different Accuracy Layers
    $(document).on('change', '#treweler-boundaries-regions-accuracy', (e) => {
      const currentAccuracy = e.target.value;

      for (let i = 0; i < this.accuracyList.length; i++) {
        if (currentAccuracy === this.accuracyList[i]) {
          TWER.map.setLayoutProperty(`boundaries-${this.accuracyList[i]}-layer`, 'visibility', 'visible');
          TWER.map.setLayoutProperty(`boundaries-${this.accuracyList[i]}-line-layer`, 'visibility', 'visible');
        } else {
          TWER.map.setLayoutProperty(`boundaries-${this.accuracyList[i]}-layer`, 'visibility', 'none');
          TWER.map.setLayoutProperty(`boundaries-${this.accuracyList[i]}-line-layer`, 'visibility', 'none');
        }
      }

      const filter = this.generateRegionsFilter($('#treweler-boundaries-regions').val());

      for (let i = 0; i < this.accuracyList.length; i++) {
        TWER.map.setFilter(`boundaries-${this.accuracyList[i]}-layer`, filter);
        TWER.map.setFilter(`boundaries-${this.accuracyList[i]}-line-layer`, filter);
      }

      this.selectRegions();
      //this.selectHiddenRegions();
      //this.tableChooser('', currentAccuracy);
    });

    // Select logic
    $(document).on('change', '.js-twer-region-active', (e) => {
      const $checkbox = $(e.target);
      const $row = $checkbox.closest('.js-twer-region-row');
      const checked = $checkbox.prop('checked');
      const customColorChecked = $row.find('.js-twer-region-override_color').prop('checked');
      //const accuracy = $('#treweler-boundaries-regions-accuracy').val();
      const feature = $row.data('feature');
      const id = parseInt(feature.id);

      if (!customColorChecked) {
        if (!this.selectStateIds.includes(id)) {
          this.fillRegionColor(id, {action: 'select'});
          this.selectStateIds.push(id);
        } else {
          this.fillRegionColor(id, {action: 'unhover'});
          this.selectStateIds = this.selectStateIds.filter(item => item !== id);
        }
      }

      $('#treweler-boundaries-regions-selected').val(JSON.stringify(this.selectStateIds));

      if (this.selectStateIdsColors.length > 0) {
        for (let i = 0; i < this.selectStateIdsColors.length; i++) {
          if (id === this.selectStateIdsColors[i].id) {
            this.selectStateIdsColors[i].selected = !!checked;
            break;
          }
        }
      }
      $('#treweler-boundaries-regions-custom-colors').val(JSON.stringify(this.selectStateIdsColors));

      this.setAllCheckboxVal();
    });

    // Link logic
    $(document).on('click', '.js-twer-del-link', (e) => {
      e.preventDefault();

      const $del = $(e.target);
      $del.removeClass('twer-del-link--active');
      const $link = $del.closest('.js-twer-link-wrap').find('.js-twer-set-link');
      $link.removeClass('twer-set-link--active');

      $link.text('');
      $link.attr('href', '');
      $link.attr('target', '');
      $link.trigger('change');

      const feature = $link.closest('.js-twer-region-row').data('feature');
      const id = parseInt(feature.id);

      this.removeLinkFromField(id);
    });

    $(document).on('click', '.js-twer-set-link', (event) => {
      event.preventDefault();

      this.setNode($(event.target));
      const $textarea = $('<textarea id="twer-link-textarea" style="display:none;"></textarea>');
      $('body').append($textarea);
      const val = this.getNodeValue();

      wpLink.open('twer-link-textarea', val.url, val.title, null);
    });

    $(document).on('wplink-open', (e) => {
      // always show title (WP will hide title if empty)
      $('#wp-link-wrap').addClass('has-text-field'); // set inputs

      const val = this.getNodeValue();

      this.setInputValue(val); // Update button text.

      if (val.url && wpLinkL10n) {
        $('#wp-link-submit').val(wpLinkL10n.update);
      }
    });

    $(document).on('wplink-close', (e) => {
      const $submit = $('#wp-link-submit');
      const isSubmit = $submit.is(':hover') || $submit.is(':focus'); // Set value

      if (isSubmit) {
        const val = this.getInputValue();
        this.setNodeValue(val);
        const feature = this.currentLinkEdit.closest('.js-twer-region-row').data('feature');
        const id = parseInt(feature.id);
        this.updateAllLinkField({id: id, ...val});
        this.setLinksFromAllLinkField();
      } // Cleanup.

      //$(document).off('wplink-open');
      //$(document).off('wplink-close');
      $('#twer-link-textarea').remove();
      this.currentLinkEdit = null;

    });

    // Custom color override checkbox logic
    $(document).on('change', '.js-twer-region-override_color', (e) => {
      const $checkbox = $(e.target);
      const checked = $checkbox.prop('checked');
      const checkedRow = $checkbox.closest('.js-twer-region-row').find('.js-twer-region-active').prop('checked');
      const feature = $checkbox.closest('.js-twer-region-row').data('feature');
      const customColor = $checkbox.closest('.js-twer-region-row').find('.input-color').val();
      const id = parseInt(feature.id);
      const selectedId = this.checkIdHasCustomColor(id);

      if (checked) {
        if (!selectedId.hasColor) {
          this.selectStateIdsColors.push({
            'id': id,
            'color': customColor,
            'active': true,
            'selected': !!checkedRow
          });
        } else {
          if (this.selectStateIdsColors.length > 0) {
            for (let i = 0; i < this.selectStateIdsColors.length; i++) {
              if (id === this.selectStateIdsColors[i].id) {
                this.selectStateIdsColors[i].active = true;
                this.selectStateIdsColors[i].selected = !!checkedRow;
                break;
              }
            }
          }
        }
      } else {
        if (this.selectStateIdsColors.length > 0) {
          for (let i = 0; i < this.selectStateIdsColors.length; i++) {
            if (id === this.selectStateIdsColors[i].id) {
              this.selectStateIdsColors[i].active = false;
              this.selectStateIdsColors[i].selected = !!checkedRow;
              break;
            }
          }
        }
      }

      $('#treweler-boundaries-regions-custom-colors').val(JSON.stringify(this.selectStateIdsColors));

      if (checked && (checkedRow || !checkedRow)) {
        this.fillRegionColor(id, {action: 'customize'});
        if (!this.selectStateIds.includes(id)) {
          this.selectStateIds.push(id);
        }
      }

      if (!checked && checkedRow) {
        this.fillRegionColor(id, {action: 'select'});
        if (!this.selectStateIds.includes(id)) {
          this.selectStateIds.push(id);
        }
      }

      if (!checked && !checkedRow) {
        this.fillRegionColor(id, {action: 'unhover'});
        this.selectStateIds = this.selectStateIds.filter(item => item !== id);
      }

      $('#treweler-boundaries-regions-selected').val(JSON.stringify(this.selectStateIds));
    });

    // Hide region logic
    $(document).on('change', '.js-twer-region-hide', (e) => {
      const $checkbox = $(e.target);
      const thisChecked = $checkbox.prop('checked');
      const feature = $checkbox.closest('.js-twer-region-row').data('feature');
      const regions = this.prepare_regions($('#treweler-boundaries-regions').val());
      const featureId = parseInt(feature.id);
      let filter = ['all'];

      if ($('#treweler-boundaries-regions').val() !== 'world') {
        filter.push(['==', ['get', regions.column], regions.value]);
        if (regions.admin !== '') {
          filter.push(['==', ['get', regions.admin], regions.admin_num]);
        }
      } else {
        filter.push(['!=', ['get', 'COUNTRY'], 'France']);
        filter.push(['!=', ['get', 'COUNTRY'], 'United States']);
        filter.push(['!=', ['get', 'COUNTRY'], 'United Kingdom']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Spain']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Italy']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Germany']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Canada']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Australia']);
      }

      if (thisChecked) {
        this.hiddenRegionsIds.add(featureId);
      } else {
        this.hiddenRegionsIds.delete(featureId);
      }
      if (this.hiddenRegionsIds.size !== 0) {
        this.hiddenRegionsIds.forEach(name => {
          filter.push(['!=', ['id'], parseInt(name)]);
        });
      }


      for (let i = 0; i < this.accuracyList.length; i++) {
        TWER.map.setFilter(`boundaries-${this.accuracyList[i]}-layer`, filter);
        TWER.map.setFilter(`boundaries-${this.accuracyList[i]}-line-layer`, filter);
      }

      $('#treweler-boundaries-regions-hide').val(JSON.stringify([...this.hiddenRegionsIds]));

      this.setHiddenCheckboxVal();
    });

    $(document).on('click', '.js-twer-region-value-cell', (e) => {
      const cell = $(e.target);
      const cellRaw = e.target;
      const $row = cell.closest('.js-twer-region-row');
      const rowFeature = $row.data('feature');
      const rowId = parseInt(rowFeature.id);

      if (!cellRaw.getElementsByTagName('input').length > 0) {
        let textValue = cellRaw.innerText.trim();
        cellRaw.innerText = '';
        let input = document.createElement('input');
        input.classList.add('large-text');
        input.type = 'text';
        if (textValue) {
          input.value = textValue;
        }
        cellRaw.appendChild(input);
        const $input = cellRaw.getElementsByTagName('input')[0];
        $input.focus();

        $input.addEventListener('blur', () => {
          const inputValue = $input.value;
          $input.remove();
          cellRaw.innerText = inputValue;
          if (inputValue.trim() !== '') {
            cellRaw.classList.add('twer-region-value-cell--has-value');
          } else {
            cellRaw.classList.remove('twer-region-value-cell--has-value');
          }
          this.updateAllValuesField({id: rowId, value: inputValue});
          //this.updateAllValuesRows(rowId, inputValue, array);
        });

        $input.addEventListener('keypress', function(e) {
          if (13 === e.keyCode) {
            e.preventDefault();

            $input.blur();
          }
        });
      }
    });

    $(document).on('change', '.js-twer-active-all-regions', (e) => {
      const $checkbox = $(e.target);
      const thisChecked = $checkbox.prop('checked');
      const $tab = $checkbox.closest('.twer-regions');
      const $rows = $tab.find('.js-twer-region-row');
      const $activeCheckboxes = $rows.find('.js-twer-region-active');
      const allData = this.table.rows().data();
      for (let i = 0; i < allData.length; i++) {
        const parsedData = JSON.parse(allData[i][6]);
        const id = parseInt(parsedData.id);
        this.selectStateIds.push(id);
      }

      if (thisChecked) {
        $activeCheckboxes.each(function(index, element) {
          $(element).prop('checked', true);
        });
      } else {
        $activeCheckboxes.each(function(index, element) {
          $(element).prop('checked', false);
        });
      }

      if (this.selectStateIds.length > 0) {
        for (let i = 0; i < this.selectStateIds.length; i++) {
          const selectedId = this.selectStateIds[i];
          const customSelectedId = this.checkIdHasCustomColor(selectedId);

          if (!customSelectedId.active) {
            if (thisChecked) {
              this.fillRegionColor(this.selectStateIds[i], {action: 'select'});
            } else {
              this.fillRegionColor(this.selectStateIds[i], {action: 'unhover'});
            }
          }

          if (this.selectStateIdsColors.length > 0) {
            for (let j = 0; j < this.selectStateIdsColors.length; j++) {
              if (selectedId === this.selectStateIdsColors[j].id) {
                this.selectStateIdsColors[j].selected = !!thisChecked;
                break;
              }
            }
          }
        }
      }

      if (!thisChecked) {
        const selectStateIdsUpdated = new Set();
        if (this.selectStateIdsColors.length > 0) {
          for (let j = 0; j < this.selectStateIdsColors.length; j++) {
            const customizedId = this.selectStateIdsColors[j].id;
            const customSelectedId = this.checkIdHasCustomColor(customizedId);
            if (this.selectStateIds.includes(customizedId) && customSelectedId.active) {
              selectStateIdsUpdated.add(customizedId);
            }
          }
        }
        this.selectStateIds = [...selectStateIdsUpdated];
      }

      this.setAllCheckboxVal(!!thisChecked, true);

      $('#treweler-boundaries-regions-selected').val(JSON.stringify(this.selectStateIds));
      $('#treweler-boundaries-regions-custom-colors').val(JSON.stringify(this.selectStateIdsColors));

      setTimeout(() => {
        this.updateDataTable();
      }, 400);

    });

    $(document).on('change', '.js-twer-hide-all-regions', (e) => {
      const $checkbox = $(e.target);
      const thisChecked = $checkbox.prop('checked');
      const $tab = $checkbox.closest('.twer-regions');
      const $rows = $tab.find('.js-twer-region-row');
      const $activeCheckboxes = $rows.find('.js-twer-region-hide');
      const allData = this.table.rows().data();
      for (let i = 0; i < allData.length; i++) {
        const parsedData = JSON.parse(allData[i][6]);
        const id = parseInt(parsedData.id);
        this.hiddenRegionsIds.add(id);
      }

      if (thisChecked) {
        $activeCheckboxes.each(function(index, element) {
          $(element).prop('checked', true);
        });
      } else {
        $activeCheckboxes.each(function(index, element) {
          $(element).prop('checked', false);
        });
      }

      let filter = ['all'];
      const regions = this.prepare_regions($('#treweler-boundaries-regions').val());

      if ($('#treweler-boundaries-regions').val() !== 'world') {
        filter.push(['==', ['get', regions.column], regions.value]);

        if (regions.admin !== '') {
          filter.push(['==', ['get', regions.admin], regions.admin_num]);
        }
      } else {
        filter.push(['!=', ['get', 'COUNTRY'], 'France']);
        filter.push(['!=', ['get', 'COUNTRY'], 'United States']);
        filter.push(['!=', ['get', 'COUNTRY'], 'United Kingdom']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Spain']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Italy']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Germany']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Canada']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Australia']);
        //filter.push(['!=', 'COUNTRY', 'France']);
      }

      if (thisChecked) {
        if (this.hiddenRegionsIds.size !== 0) {
          this.hiddenRegionsIds.forEach(name => {
            filter.push(['!=', ['id'], parseInt(name)]);
          });
        }
      } else {
        this.hiddenRegionsIds = new Set();
      }

      console.log(filter);

      for (let i = 0; i < this.accuracyList.length; i++) {
        TWER.map.setFilter(`boundaries-${this.accuracyList[i]}-layer`, filter);
        TWER.map.setFilter(`boundaries-${this.accuracyList[i]}-line-layer`, filter);
      }

      this.setHiddenCheckboxVal(!!thisChecked, true);

      $('#treweler-boundaries-regions-hide').val(JSON.stringify([...this.hiddenRegionsIds]));

      setTimeout(() => {
        this.updateDataTable();
      }, 400);
    });



    function togglePrefixField(value) {
      if (typeof value === 'undefined') {
        value = $('#treweler-boundaries-onhover').val();
      }
      if (value === 'popup_value') {
        $('#treweler-boundaries-onhover-prefix').css('visibility', 'visible');
      } else {
        $('#treweler-boundaries-onhover-prefix').css('visibility', 'hidden');
      }
    }

    $(document).on('change', '#treweler-boundaries-onhover', (e) => {
      togglePrefixField(e.target.value);
    });
    togglePrefixField();
  }

  setHiddenCheckboxVal(value = false, notIgnoreSelf = false) {
    const allCheckboxSelected = this.getAllCheckboxVal();
    if (allCheckboxSelected.length > 0) {
      for (let i = 0; i < allCheckboxSelected.length; i++) {
        this.allCheckboxesStates[i].hide = value;
      }
    } else {
      this.allCheckboxesStates.push({'hide': value});
    }

    if (!notIgnoreSelf) {
      $('.js-twer-hide-all-regions').prop('checked', value);
    }
    $('#treweler-boundaries-all-checkboxes').val(JSON.stringify(this.allCheckboxesStates));
  }

  updateAllLinkField(linkParams) {
    if (!this.allLinksHasLink(linkParams.id)) {
      this.allLinks.push(linkParams);
    } else {
      for (let i = 0; i < this.allLinks.length; i++) {
        if (this.allLinks[i].id === linkParams.id) {
          this.allLinks[i].id = linkParams.id;
          this.allLinks[i].title = linkParams.title;
          this.allLinks[i].url = linkParams.url;
          this.allLinks[i].target = linkParams.target;
        }
      }
    }

    document.getElementById('treweler-boundaries-links').value = JSON.stringify(this.allLinks);
  }

  getInputValue() {
    return {
      title: $('#wp-link-text').val(),
      url: $('#wp-link-url').val(),
      target: $('#wp-link-target').prop('checked') ? '_blank' : ''
    };
  }

  setInputValue(val) {
    $('#wp-link-text').val(val.title);
    $('#wp-link-url').val(val.url);
    $('#wp-link-target').prop('checked', val.target === '_blank');
  }

  getNodeValue() {
    const $node = this.currentLinkEdit;
    return {
      title: $node.html(),
      url: $node.attr('href'),
      target: $node.attr('target')
    };
  }

  setNodeValue(val) {
    const $node = this.currentLinkEdit;
    $node.text(val.title);
    $node.attr('href', val.url);
    $node.attr('target', val.target);
    $node.trigger('change');
  }

  setNode($node) {
    this.currentLinkEdit = $node;
  }

  allLinksHasLink(id) {
    let result = false;
    const value = this.getFeatureLinkVal(id);
    if (value.hasOwnProperty('title')) {
      result = true;
    }
    return result;
  }

  removeLinkFromField(id) {
    if (this.allLinksHasLink(id)) {
      const allLinksVal = this.getAllLinks();
      for (let i = 0; i < allLinksVal.length; i++) {
        if (allLinksVal[i].id === id) {
          this.allLinks = this.allLinks.filter(item => item.id !== id);
        }
      }

      document.getElementById('treweler-boundaries-links').value = JSON.stringify(this.allLinks);
    }
  }

  updateAllValuesRows(id, value, cells) {
    cells.map((cell, index, array) => {
      const $row = cell.closest('.js-twer-region-row');
      const rowFeature = JSON.parse($row.dataset.feature);
      const rowId = parseInt(rowFeature.id);

      if (rowId === id) {
        cell.innerText = value;
        if (value.trim() !== '') {
          cell.classList.add('twer-region-value-cell--has-value');
        } else {
          cell.classList.remove('twer-region-value-cell--has-value');
        }
      }
    });

  }

  getAllValues() {
    this.allValues = this.allValues.length > 0 ? this.allValues : $('#treweler-boundaries-values-regions').val().trim();
    if (!Array.isArray(this.allValues)) {
      if (this.allValues === '') {
        this.allValues = '[]';
      }
      this.allValues = JSON.parse(this.allValues);
    }

    return this.allValues;
  }

  getFeatureValueVal(id) {
    let result = false;
    const allValuesVals = this.getAllValues();
    if (allValuesVals.length > 0) {
      for (let i = 0; i < allValuesVals.length; i++) {
        const valuesData = allValuesVals[i];
        if (valuesData.id === id) {
          result = {
            value: valuesData.value,
          };
        }
      }
    }

    return result;
  }

  allValuesHasVal(id) {
    let result = false;
    const value = this.getFeatureValueVal(id);
    if (value.hasOwnProperty('value')) {
      result = true;
    }
    return result;
  }

  updateAllValuesField(valueParams) {
    if (!this.allValuesHasVal(valueParams.id)) {
      this.allValues.push(valueParams);
    } else {
      for (let i = 0; i < this.allValues.length; i++) {
        if (this.allValues[i].id === valueParams.id) {
          this.allValues[i].id = valueParams.id;
          this.allValues[i].value = valueParams.value;
        }
      }
    }

    document.getElementById('treweler-boundaries-values-regions').value = JSON.stringify(this.allValues);
  }

  allValuesIsEmpty() {
    return this.getAllValues().length <= 0;
  }

  setValuesFromAllValuesField() {
    if (!this.allValuesIsEmpty()) {
      const $rows = document.getElementsByClassName('js-twer-region-row');
      for (let i = 0; i < $rows.length; i++) {
        const $row = $rows[i];
        const $cell = $row.getElementsByClassName('js-twer-region-value-cell')[0];
        const rowFeature = JSON.parse($row.dataset.feature);
        const regionId = parseInt(rowFeature.id);
        const valueData = this.getFeatureValueVal(regionId);
        if (valueData) {
          $cell.innerText = valueData.value;
          $cell.classList.add('twer-region-value-cell--has-value');
        }

      }
    }
  }

  getAllLinks() {
    this.allLinks = this.allLinks.length > 0 ? this.allLinks : $('#treweler-boundaries-links').val().trim();
    if (!Array.isArray(this.allLinks)) {
      if (this.allLinks === '') {
        this.allLinks = '[]';
      }
      this.allLinks = JSON.parse(this.allLinks);
    }

    return this.allLinks;
  }

  allLinksIsEmpty() {
    return this.getAllLinks().length <= 0;
  }

  getFeatureLinkVal(id) {
    let result = false;
    const allLinks = this.getAllLinks();
    if (allLinks.length > 0) {
      for (let i = 0; i < allLinks.length; i++) {
        const linkData = allLinks[i];
        if (linkData.id === id) {
          result = {
            id: linkData.id,
            title: linkData.title,
            url: linkData.url,
            target: linkData.target
          };
        }
      }
    }

    return result;
  }

  setLinksFromAllLinkField() {
    if (!this.allLinksIsEmpty()) {
      const $rows = document.getElementsByClassName('js-twer-region-row');
      for (let i = 0; i < $rows.length; i++) {
        const $row = $rows[i];
        const $link = $row.getElementsByClassName('js-twer-set-link')[0];
        const $wrap = $link.closest('.js-twer-link-wrap');
        const $del = $wrap.getElementsByClassName('js-twer-del-link')[0];
        const rowFeature = JSON.parse($row.dataset.feature);
        const regionId = parseInt(rowFeature.id);
        const linkData = this.getFeatureLinkVal(regionId);
        if (linkData) {
          $link.href = linkData.url;
          $link.title = linkData.title;
          $link.innerText = linkData.title;
          $link.target = linkData.target;
          $link.classList.add('twer-set-link--active');
          $del.classList.add('twer-del-link--active');
        }

      }
    }
  }

  selectRegions() {
    this.selectStateIds = this.selectStateIds.length > 0 ? this.selectStateIds : $('#treweler-boundaries-regions-selected').val().trim();

    if (!Array.isArray(this.selectStateIds)) {
      if (this.selectStateIds === '') {
        this.selectStateIds = '[]';
      }
      this.selectStateIds = JSON.parse(this.selectStateIds);
    }

    this.selectStateIdsColors = this.selectStateIdsColors.length > 0 ? this.selectStateIdsColors : $('#treweler-boundaries-regions-custom-colors').val().trim();

    if (!Array.isArray(this.selectStateIdsColors)) {
      if (this.selectStateIdsColors === '') {
        this.selectStateIdsColors = '[]';
      }
      this.selectStateIdsColors = JSON.parse(this.selectStateIdsColors);
    }

    if (this.selectStateIds.length > 0) {
      for (let i = 0; i < this.selectStateIds.length; i++) {
        this.fillRegionColor(this.selectStateIds[i], {action: 'select'});
      }
    }

    if (this.selectStateIdsColors.length > 0) {
      for (let i = 0; i < this.selectStateIdsColors.length; i++) {
        if (this.selectStateIdsColors[i].active && this.selectStateIds.includes(this.selectStateIdsColors[i].id)) {
          this.fillRegionColor(this.selectStateIdsColors[i].id, {action: 'customize'});
        }
      }
    }
  }

  selectHiddenRegions() {
    this.hiddenRegionsIds = this.hiddenRegionsIds.size !== 0 ? this.hiddenRegionsIds : $('#treweler-boundaries-regions-hide').val().trim();

    if (typeof this.hiddenRegionsIds === 'string') {
      if (this.hiddenRegionsIds === '') {
        this.hiddenRegionsIds = '[]';
      }
      this.hiddenRegionsIds = new Set(JSON.parse(this.hiddenRegionsIds));
    }

    const regions = this.prepare_regions(this.$regionsSelect.value);

    let filter = ['all'];

    if (this.$regionsSelect.value !== 'world') {
      filter.push(['==', ['get', regions.column], regions.value]);

      if (regions.admin !== '') {
        filter.push(['==', ['get', regions.admin], regions.admin_num]);
      }
    } else {
      //filter.push(['!=', 'COUNTRY', 'France']);
    }

    if (this.hiddenRegionsIds.size !== 0) {
      this.hiddenRegionsIds.forEach(name => {
        filter.push(['!=', ['id'], parseInt(name)]);
      });

      for (let i = 0; i < this.accuracyList.length; i++) {
        TWER.map.setFilter(`boundaries-${this.accuracyList[i]}-layer`, filter);
        TWER.map.setFilter(`boundaries-${this.accuracyList[i]}-line-layer`, filter);
      }
    }
  }

  generateRegionsFilter(choosedRegion) {
    let bCheckded = $('#treweler-boundaries').prop('checked');
    const filter = ['all'];
    this.hiddenRegionsIds = this.hiddenRegionsIds.size !== 0 ? this.hiddenRegionsIds : $('#treweler-boundaries-regions-hide').val().trim();

    if (typeof this.hiddenRegionsIds === 'string') {
      if (this.hiddenRegionsIds === '') {
        this.hiddenRegionsIds = '[]';
      }
      this.hiddenRegionsIds = new Set(JSON.parse(this.hiddenRegionsIds));
    }
    if (bCheckded) {
      if (choosedRegion !== 'world') {
        const regions = this.prepare_regions(choosedRegion);

        filter.push(['==', ['get', regions.column], regions.value]);
        if (regions.admin !== '') {
          filter.push(['==', ['get', regions.admin], regions.admin_num]);
        }
      } else {
        //filter.push(['!=', 'mode', 'static']);
        filter.push(['!=', ['get', 'COUNTRY'], 'France']);
        filter.push(['!=', ['get', 'COUNTRY'], 'United States']);
        filter.push(['!=', ['get', 'COUNTRY'], 'United Kingdom']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Spain']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Italy']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Germany']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Canada']);
        filter.push(['!=', ['get', 'COUNTRY'], 'Australia']);
      }

      if (this.hiddenRegionsIds.size !== 0) {
        this.hiddenRegionsIds.forEach(name => {
          filter.push(['!=', ['id'], parseInt(name)]);
        });
      }
    } else {
      filter.push(['==', 'mode', 'static']);
    }

    return filter;
  }

  getAllCheckboxVal() {
    this.allCheckboxesStates = this.allCheckboxesStates.length > 0 ? this.allCheckboxesStates : $('#treweler-boundaries-all-checkboxes').val().trim();
    if (!Array.isArray(this.allCheckboxesStates)) {
      if (this.allCheckboxesStates === '') {
        this.allCheckboxesStates = '[]';
      }
      this.allCheckboxesStates = JSON.parse(this.allCheckboxesStates);
    }

    return this.allCheckboxesStates;
  }

  setAllCheckboxVal(value = false, notIgnoreSelf = false) {
    const allCheckboxSelected = this.getAllCheckboxVal();
    if (allCheckboxSelected.length > 0) {
      for (let i = 0; i < allCheckboxSelected.length; i++) {
        this.allCheckboxesStates[i].active = value;
      }
    } else {
      this.allCheckboxesStates.push({'active': value});
    }

    if (!notIgnoreSelf) {
      $('.js-twer-active-all-regions').prop('checked', value);
    }
    $('#treweler-boundaries-all-checkboxes').val(JSON.stringify(this.allCheckboxesStates));
  }

  applyRegionColor(rootElement, color) {
    rootElement.find('.color-holder').css('background-color', color);
    rootElement.find('.input-color').val(color);
    rootElement.find('.js-twer-color-picker-palette-o').attr('acp-color', color);
  }

  checkIdHasCustomColor(id) {
    let hasColor = false;
    let index = 0;
    let active = false;
    let selected = true;

    if (this.selectStateIdsColors.length > 0) {
      for (let i = 0; i < this.selectStateIdsColors.length; i++) {
        if (id === this.selectStateIdsColors[i].id) {
          hasColor = true;
          index = i;
          active = this.selectStateIdsColors[i].active;
          selected = !!this.selectStateIdsColors[i].selected;
          break;
        }
      }
    }

    return {hasColor: hasColor, index: index, active: active, selected: selected};
  }

  generateFeatureStateFilter(settings = {}) {
    const fillMain = 'main' in settings ? settings.main : $('#treweler-boundaries-fill-main .input-color').val();
    const fillHover = 'hover' in settings ? settings.hover : $('#treweler-boundaries-fill-hover .input-color').val();
    const fillSelect = 'select' in settings ? settings.select : $('#treweler-boundaries-fill-selected .input-color').val();
    this.selectStateIdsColors = this.selectStateIdsColors.length > 0 ? this.selectStateIdsColors : $('#treweler-boundaries-regions-custom-colors').val().trim();

    if (!Array.isArray(this.selectStateIdsColors)) {
      if (this.selectStateIdsColors === '') {
        this.selectStateIdsColors = '[]';
      }
      this.selectStateIdsColors = JSON.parse(this.selectStateIdsColors);
    }

    const filter = [
      'match',
      ['feature-state', 'action'],
      'hover',
      fillHover,
      'select',
      fillSelect,
      'unselect',
      fillHover,
      'unhover',
      fillMain,
      fillMain
    ];

    if (this.selectStateIdsColors.length > 0) {
      let spliceCounter = 0;
      for (let i = 0; i < this.selectStateIdsColors.length; i++) {
        if (this.selectStateIdsColors[i].active) {
          let splice1 = 2 + spliceCounter;
          let splice2 = 3 + spliceCounter;
          filter.splice(splice1, 0, `customize_${this.selectStateIdsColors[i].id}`);
          filter.splice(splice2, 0, this.selectStateIdsColors[i].color);
          spliceCounter = spliceCounter + 2;
        }
      }
    }

    return filter;
  }

  boundariesCheckboxWatch() {
    this.$boundariesCheckbox.addEventListener('change', (e) => {
      if (e.target.checked) {
        this.loadBoundaries();
      } else {
        this.unloadBoundaries();
      }
    });

    if (this.$boundariesCheckbox.checked) {
      this.loadBoundaries();
    } else {
      this.unloadBoundaries();
    }
  }

  updateSelectRegionsList() {
    let child = this.$regionsSelect.lastElementChild;
    const currentValue = this.$regionsSelect.dataset.value || 'world';

    while (child) {
      this.$regionsSelect.removeChild(child);
      child = this.$regionsSelect.lastElementChild;
    }

    this.$regionsSelect.appendChild(new Option(__('World', 'treweler'), 'world', true, true));

    for (let i = 0; i < this.regionsList.length; i++) {
      const $group = document.createElement('optgroup');
      $group.label = this.regionsList[i].label;

      if (this.regionsList[i].options.length > 0) {
        for (let j = 0; j < this.regionsList[i].options.length; j++) {
          const $option = document.createElement('option');

          $option.value = this.regionsList[i].options[j].value;
          $option.innerHTML = this.regionsList[i].options[j].label;
          if (currentValue === this.regionsList[i].options[j].value) {
            $option.setAttribute('selected', true);
          }
          $group.appendChild($option);
        }
      }

      this.$regionsSelect.appendChild($group);
    }
  }

  generateRegionsList() {
    const regions = {
      COUNTRY: {
        ADMIN_1: {
          label: __('Countries Admin 01', 'treweler'),
        },
        ADMIN_2: {
          label: __('Countries Admin 02', 'treweler'),
        }
      },
      CONTINENT: {
        label: __('Continent', 'treweler'),
      },
      REGION_UN: {
        label: __('Region UN', 'treweler'),
      },
      REGION_WB: {
        label: __('Region WB', 'treweler'),
      },
      SUBREGION: {
        label: __('Subregion', 'treweler'),
      }
    };
    const features = this.worldsGeoJson.very_high.features;

    for (let column in regions) {
      if ('COUNTRY' === column) {
        for (let columnInner in regions[column]) {
          regions[column][columnInner].options = new Set();
        }
      } else {
        regions[column].options = new Set();
      }
      if (features.length > 0) {
        for (let i = 0; i < features.length; i++) {
          const properties = features[i].properties;

          if ('COUNTRY' === column) {
            for (let columnInner in regions[column]) {
              if (properties.hasOwnProperty(column) && properties.hasOwnProperty(columnInner.slice(0, -2))) {
                if (properties[columnInner.slice(0, -2)] === 1) {
                  regions[column][columnInner].options.add(properties[column]);
                }
                if (properties[columnInner.slice(0, -2)] === 2) {
                  regions[column][columnInner].options.add(properties[column]);
                }
              }
            }
          } else {
            if (properties.hasOwnProperty(column)) {
              regions[column].options.add(properties[column]);
            }
          }

        }
      }
    }

    for (let column in regions) {

      if ('COUNTRY' === column) {
        for (let columnInner in regions[column]) {
          regions[column][columnInner].options = [...regions[column][columnInner].options].sort((a, b) => a.localeCompare(b));

          for (let i = 0; i < regions[column][columnInner].options.length; i++) {
            let optionLabel = regions[column][columnInner].options[i];
            let valueObj = {};

            regions[column][columnInner].options[i] = {};
            regions[column][columnInner].options[i].label = optionLabel;
            valueObj[column] = optionLabel;

            valueObj[columnInner.slice(0, -2)] = parseInt(columnInner.charAt(columnInner.length - 1));
            regions[column][columnInner].options[i].value = JSON.stringify(valueObj);
          }
        }
      } else {
        regions[column].options = [...regions[column].options].sort((a, b) => a.localeCompare(b));
        for (let i = 0; i < regions[column].options.length; i++) {
          let optionLabel = regions[column].options[i];
          let valueObj = {};

          regions[column].options[i] = {};
          regions[column].options[i].label = optionLabel;
          valueObj[column] = optionLabel;
          regions[column].options[i].value = JSON.stringify(valueObj);
        }
      }
    }

    return [
      regions.COUNTRY.ADMIN_1,
      regions.COUNTRY.ADMIN_2,
      regions.CONTINENT,
      regions.REGION_UN,
      regions.REGION_WB,
      regions.SUBREGION
    ];
  }

  prepareGeoJson(geoJSON) {
    for (let quality in geoJSON) {
      if (geoJSON[quality].features.length > 0) {
        let geoId = 1;
        for (let u = 0; u < geoJSON[quality].features.length; u++) {
          geoJSON[quality].features[u].id = geoId;
          geoId++;
        }
      }
    }
    return geoJSON;
  }

  worldListFill() {
    for (let j = 0; j < this.accuracyList.length; j++) {
      const accuracyKey = this.accuracyList[j];
      const accuracy = accuracyKey.replace(/_/g, '-');

      this.worldsList[accuracyKey] = {
        urls: []
      };

      for (let i = 0; i < this.worldsSlugs.length; i++) {
        const slug = this.worldsSlugs[i];

        if (slug === 'world') {
          this.worldsList[accuracyKey].urls.push(`${slug}-${accuracy}.json`);
        } else {
          this.worldsList[accuracyKey].urls.push(`${slug}-${accuracy}-01.json`, `${slug}-${accuracy}-02.json`);
        }
      }
    }
  }

  async fetchData() {
    const geoJsonData = {};

    for (let q = 0; q < this.accuracyList.length; q++) {
      const quality = this.accuracyList[q];
      let sourceGeoJsonResult = await Promise.all(this.worldsList[quality].urls.map(urlJson =>
        fetch(`${twer_ajax.data}${urlJson}`).then(resp => resp.json())
      ));


      geoJsonData[quality] = {
        type: '',
        features: []
      };

      if (sourceGeoJsonResult.length > 0) {
        for (let i = 0; i < sourceGeoJsonResult.length; i++) {
          geoJsonData[quality].type = sourceGeoJsonResult[i].type;
          geoJsonData[quality].features.push(...sourceGeoJsonResult[i].features);
        }
      }
    }



    return geoJsonData;
  }

}

!(() => {
  window.addEventListener('load', () => {
    new TWER_BOUNDARIES();
  });
})();


